export default __webpack_public_path__ + "static/media/avatar.244b95a6.svg";